export default __webpack_public_path__ + "static/media/rl-2-rMIN.995bad23.jpg";